<div class="courses-body void">
  <span class="courses-icon glicon-none-itinerary"></span>
  <span class="courses-void__title">{{ 'itineraries.empty.heading' | translate }}</span>
  <span class="courses-void__subtitle">{{ 'itineraries.empty.text' | translate }}.</span>
  <div *ngIf="!clientView">
    <gl-button
      color-secondary
      [disabled]="!isCorporateWithSubscriptionClient"
      *lmsProfileGuard="'training.itineraries.create'"
      [text]="'actions.createItinerary' | translate"
      [routerLink]="['/itineraries/new']"
    ></gl-button>
  </div>
</div>
